<template>
  <span>
    <span
      v-if="user && user.subscription_status === 'active' && !user.with_gift && checkGift()"
      class="block w-3 h-3 m-1 bg-subscribed rounded-full"
      :class="user.subscription_type === 'premium' ? 'bg-premium' : 'bg-subscribed'"
    ></span>
    <span
      v-else-if="user.stripe_plan && !user.with_gift && checkGift()"
      class="block w-3 h-3 m-1 bg-subscribed rounded-full"
      :class="checkSubscriptionType() === 'premium' ? 'bg-premium' : 'bg-subscribed'"
    ></span>
  </span>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "SubscriptionType",
  props: {
    user: Object
  },
  methods: {
    checkGift() {
      return process.env.MIX_STRIPE_PLAN8 != this.user.stripe_plan;
    },
    checkSubscriptionType() {
      let type = 'subscribed';

      const premiumPlans = [
          process.env.MIX_STRIPE_PLAN0,
          process.env.MIX_STRIPE_PLAN2,
          process.env.MIX_STRIPE_PLAN5,
          process.env.MIX_STRIPE_PLAN6,
          process.env.MIX_STRIPE_PLAN0_OLD,
          process.env.MIX_STRIPE_PLAN2_OLD,
          process.env.MIX_STRIPE_PLAN5_OLD,
          process.env.MIX_STRIPE_PLAN6_OLD,
          process.env.MIX_STRIPE_PLAN_15_DAY
      ];

      if (premiumPlans.includes(this.user.stripe_plan)) {
          type = 'premium';
      }

      return type;
    }
  }
};
</script>
<style>
  .bg-subscribed {
    background: linear-gradient(90deg, #266cd2 0%, #3A91F9 100%);
  }
  .bg-premium {
    background: linear-gradient(90deg, #FFC107 0%, #FFEB3B 100%);
  }
</style>
